<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}"><tui-icon icon="lightbulb"/></span>
}
</label>

<div class="accordion-item__right" [ngClass]="isTextArea ? 'new' : ''">
  <form [formGroup]="form" style="width: 100%;">
    @if (!isTextArea) {
      <input nbInput
        #inputTextArea
        type="text"
        fullWidth
        fieldSize="medium"
        [placeholder]="valueExample ? valueExample : 'Текстовое значение'"
        formControlName="featureValue"
        />
    }

    @if (isTextArea) {
      <textarea class="input-text-area" [ngClass]="isLongContent && trimString === true ? 'show' : 'hide'"
        #inputTextArea
        nbInput
        type="text"
        fullWidth
        fieldSize="medium"
        [placeholder]="valueExample ? valueExample : 'Текстовое значение'"
        formControlName="featureValue"
        (input)="resizeOnTextAreaInput($event)"
      ></textarea>
    }
    @if (featureValue.invalid && (featureValue.dirty || featureValue.touched)) {
      <div>
        @if (featureValue.hasError('required')) {
          <div class="text-danger" i18n="@@FeatureValueRequiredError">
        Поле обязательно для заполнения
      </div>
        }
        @if (featureValue.hasError('pattern')) {
          <div class="text-danger" i18n="@@FeatureValueIncorrectPatternError">
        Не корректное значение
      </div>
        }
        @if (featureValue.hasError('url')) {
          <div class="text-danger" i18n="@@FeatureValueUrlError">
        Не корректное значение адреса
      </div>
        }
        @if (featureValue.hasError('email')) {
          <div class="text-danger" i18n="@@FeatureValueEmailError">
        Не корректное значение адреса электронной почты
      </div>
        }
        @if (featureValue.hasError('minlength')) {
          <div class="text-danger" i18n="@@FeatureValueMinLengthError">
        Минимум {{ featureValue.errors.minlength.requiredLength }} символов
      </div>
        }
        @if (featureValue.hasError('maxlength')) {
          <div class="text-danger" i18n="@@FeatureValueMaxLengthError">
        Превышен лимит символов: {{ featureValue.errors.maxlength.actualLength }}
        из {{ featureValue.errors.maxlength.requiredLength }}
      </div>
        }
        @if (featureValue.hasError('stringContent')) {
          <div>
            @if (customValidator.useDigits) {
              <div [ngClass]="featureValue.errors.stringContent.hasNotNumber ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotNumberError">
          Поле должно содержать хотя бы 1 цифру!
        </div>
            }
            @if (customValidator.useCharacters) {
              <div [ngClass]="featureValue.errors.stringContent.hasNotCharacters ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotCharactersError">
          Поле должно содержать хотя бы 1 букву ({{ featureValue.errors.stringContent.allowedAlphabets.join(', ') }}) ({{ featureValue.errors.stringContent.allowedCharactersCases.join(', ') }})
        </div>
            }
            @if (customValidator.useCharacters) {
              <div [ngClass]="featureValue.errors.stringContent.hasNotSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotSymbolsError">
          Поле должно содержать хотя бы 1 символ ({{ featureValue.errors.stringContent.allowedSymbols.join(', ') }})!
        </div>
            }
            <div [ngClass]="featureValue.errors.stringContent.hasOtherSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasOtherSymbolsError">
          Поле не должно содержать других символов
        </div>
          </div>
        }
      </div>
    }
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    <div class="item">
      @if (featureValue.valid && isShowEmptyWarning()) {
        <div class="state-warn">
          <tui-icon icon="triangle-alert"/>
        </div>
      }
      @if (featureValue.invalid) {
        <div class="state-err">
          <tui-icon icon="circle-alert"/>
        </div>
      }
      @if (featureValue.valid && !isEmpty()) {
        <div class="state-success">
          <tui-icon icon="check"/>
        </div>
      }

      @if (featureLink) {
        <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
          class="entityID"
          target="_blank"
          i18n-nbTooltip="@@OpenFeatureInNewWindow"
          nbTooltip="Открыть характеристику в новом окне"
          >
          #{{ feature.featureId }}
        </a>
      }
    </div>

    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>

  @if (isTextArea) {
    <div class="show-block" (click)="toggleTextarea();" [ngClass]="isLongContent && trimString === false ? '' : 'hide'">
      @if (isLongContent && trimString) {
        <p i18n="@@Podrobnee">Подробнее</p>
      }
      @if (isLongContent && !trimString) {
        <p i18n="@@Skryt">Скрыть</p>
      }
      @if (isLongContent) {
        <img class="ar-more" src="/assets/images/ar-more.svg" width="24" height="24" alt="">
      }
    </div>
  }
</div>
